import type { FilterFn } from '@tanstack/react-table';

import { matchesSearch } from '../../../utils/textSearch';

type Text = string | null | undefined;

const toText = (value: unknown): Text => {
  if (value == null) return null;
  if (Array.isArray(value)) return value.map((item) => String(item ?? '')).join(' ');
  return String(value);
};

/**
 * `filterFn` de TanStack para buscadores de texto: sin mayúsculas, sin acentos
 * y por palabras (`matchesSearch`). Sustituye a `'includesString'`, que solo
 * pasa a minúsculas y exige la cadena literal («eric» no encontraba «Èric»).
 *
 * Sin `fields` busca en el valor de la propia columna. Con `fields`, en los
 * campos de la fila que se le digan: así la columna «Nombre» puede buscar en
 * nombre y apellidos a la vez («anna roura»).
 *
 * `autoRemove` quita el filtro cuando la búsqueda queda vacía, como hacen los
 * filtros de fábrica de TanStack.
 */
export function textSearchFilter<TData>(
  fields?: (row: TData) => ReadonlyArray<Text>
): FilterFn<TData> {
  const filter: FilterFn<TData> = (row, columnId, filterValue) =>
    matchesSearch(
      fields ? fields(row.original) : [toText(row.getValue(columnId))],
      toText(filterValue)
    );
  filter.autoRemove = (value) => !toText(value)?.trim();
  return filter;
}
